import { useQuizContext } from "./QuizContext";

export function useTreats(dogId: string) {
  const { state, dispatch } = useQuizContext();

  const selections = state.treatSelections?.[dogId] || {};

  const setTreats = (updater: any) =>
    dispatch({
      type: "SET_TREATS",
      dogId,
      payload: typeof updater === "function" ? updater(selections) : updater,
    });

  return {
    selections,
    setTreats,
  };
}
